import type { BusinessActivity } from '@/services/business-activities';
import { Fragment, type ReactNode } from 'react';
import { capitalizeFirst } from './format-underwriting-messages.util';

/**
 * Substitui códigos de atividade citados em mensagens de validação do
 * attach-element (ex.: "A atividade 163 não é aceita para este produto")
 * pela descrição do catálogo de atividades empresariais, já carregado na
 * própria página — em negrito e capitalizada (ex.: "Abatedouro").
 * Código sem correspondência no catálogo é mantido como está.
 */
export function replaceActivityCodesWithNames(
  message: string,
  activities: BusinessActivity[] | undefined
): ReactNode {
  if (!message || !activities?.length) return message;

  const pattern = /(\batividades?\s+)(\d+)\b/gi;
  const parts: ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  while ((match = pattern.exec(message)) !== null) {
    const [fullMatch, prefix, code] = match;
    const description = activities
      .find(activity => String(activity.code) === code)
      ?.description?.trim();
    if (!description) continue;

    parts.push(
      <Fragment key={`${match.index}-text`}>
        {message.slice(lastIndex, match.index)}
        {prefix}
      </Fragment>,
      <strong key={`${match.index}-activity`}>
        {capitalizeFirst(description)}
      </strong>
    );
    lastIndex = match.index + fullMatch.length;
  }

  if (parts.length === 0) return message;

  parts.push(
    <Fragment key='tail'>{message.slice(lastIndex)}</Fragment>
  );
  return <>{parts}</>;
}
